import { Injectable } from "@angular/core";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LeftNavService {

  public test = true;

  /**
   * If the left navigation menu is collapsed or opened
   */
  public collapsed$ = new BehaviorSubject(false);

  /**
   * If the user has manually toggled the left nav
   */
  protected _manual$ = new BehaviorSubject(false);

  constructor(breakpointObserver: BreakpointObserver) {
    breakpointObserver
      .observe([
        "(max-width : 1000px)",
      ])
      .subscribe((result) => this._breakpointChanged(result));
  }

  /**
   * Toggle the side nav
   *
   * @param forceCollapse Force the side nav to be collapsed / opened
   */
  public toggleCollapse(forceCollapse?: boolean) {
    if (typeof forceCollapse === "boolean") {
      this.collapsed$.next(forceCollapse);
    } else {
      this.collapsed$.next(!this.collapsed$.getValue());
      this._manual$.next(true);
    }
  }

  /**
   * Breakpoint has changed
   *
   * @param result The status of the breakpoint
   */
  protected _breakpointChanged(result: BreakpointState) {
    if (!this._manual$.getValue()) {
      this.toggleCollapse(result.matches);
    }
  }
}
